import { Navigate } from 'react-router-dom'
import { LicenseShoppingCart } from 'components'
import {
    ENABLE_ACCOUNT_PLAN_PAGE,
    ENABLE_LICENSE_SHOPPING_CART,
} from 'utility/subscription-usage'

export const LicenseCheckoutScreen = () =>
    ENABLE_LICENSE_SHOPPING_CART ? (
        <LicenseShoppingCart />
    ) : (
        <Navigate
            to={
                ENABLE_ACCOUNT_PLAN_PAGE
                    ? '/app/settings/account-plan'
                    : '/app/settings'
            }
            replace
        />
    )
